import React, { memo } from 'react';

import { Container } from './styles';

const UniBreakLines = ({ text }) => text.split('\n').map((content, key) => <Container key={`hp${key}`}>{content}</Container>);

export default memo(UniBreakLines);
